import React from 'react';

import { T } from '../../../../../../common/locale/translate';
import Row from '../../../../common/components/responsive-table-row';
import Cell from '../../../../common/components/responsive-table-cell';

export default class WeatherGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      temperature_offset: 4,
      day_color: 'rgba(255, 180, 0, .8)',
      day_top_color: 'rgba(255, 222, 42, .8)',
      night_color: 'rgba(15, 193, 179, .8)',
      day_night_height: 250,
      simple_bars_height: 60,
      colors: {
        'temperature-day-night': {
          day_color: 'rgba(255, 180, 0, .8)',
          day_top_color: 'rgba(255, 222, 42, .8)',
          night_color: 'rgba(15, 193, 179, .8)'
        },
        'temperature-only-day': {
          day_color: 'rgba(255, 180, 0, .8)',
          day_top_color: 'rgba(255, 222, 42, .8)',
          night_color: 'rgba(15, 193, 179, .8)'
        },
        'temperature-water': 'rgba(15, 117, 189, .8)',
        'temperature-sunlight-hours': 'rgba(255, 180, 0, .8)',
        'temperature-rainy-days': 'rgba(146, 161, 202, .8)'
      }
    };
  }

  render = () => (
    <Row
      headers={this.props.headers}
      className={`${this.props.className ? this.props.className : ''}`}
    >
      {this.props.headers.map((header, i) =>
        this.ComponentElements(header.name, i)
      )}
    </Row>
  );

  ComponentElements(key, index) {
    const data = this.props.data,
      name = `${key}-${data.type}`;

    const elements = {
      'legend-temperature-day-night': (data, index) => (
        <Cell
          className="legend legend-temperature-day-night"
          key={`day-night-${index}`}
        >
          <div className="legend-wrapper">
            <div className="header-wrapper">
              <i className="fa fa-thermometer-three-quarters" />
              <span className="title">{T('celsius_temperature')}</span>
            </div>
            <div className="legend-colors">
              <div className="day-wrapper">
                <span className="color" />
                <span className="title">{T('day')}</span>
              </div>
              <div className="night-wrapper">
                <span className="color" />
                <span className="title">{T('night')}</span>
              </div>
            </div>
          </div>
        </Cell>
      ),
      'legend-temperature-only-day': (data, index) => (
        <Cell
          className="legend legend-temperature-day-night"
          key={`day-night-${index}`}
        >
          <div className="legend-wrapper">
            <div className="header-wrapper">
              <i className="fa fa-thermometer-three-quarters" />
              <span className="title">{T('celsius_temperature')}</span>
            </div>
            <div className="legend-colors">
              <div className="day-wrapper">
                <span className="color" />
                <span className="title">{T('day')}</span>
              </div>
            </div>
          </div>
        </Cell>
      ),
      'legend-temperature-water': (data, index) => (
        <Cell
          className="legend legend-temperature-water"
          key={`day-night-${index}`}
        >
          <div className="legend-wrapper">
            <div className="header-wrapper">
              <i className="fa fa-thermometer-three-quarters" />
              <span className="title">{T('water_celsius_temperature')}</span>
            </div>
          </div>
        </Cell>
      ),
      'legend-temperature-sunlight-hours': (data, index) => (
        <Cell
          className="legend legend-sunlight-hours"
          key={`day-night-${index}`}
        >
          <div className="legend-wrapper">
            <div className="header-wrapper">
              <i className="fa fa-sun-o" />
              <span className="title">{T('sunny_hours_per_day')}</span>
            </div>
          </div>
        </Cell>
      ),
      'legend-temperature-rainy-days': (data, index) => (
        <Cell className="legend legend-rainy-days" key={`day-night-${index}`}>
          <div className="legend-wrapper">
            <div className="header-wrapper">
              <i className="fa fa-tint" />
              <span className="title">{T('rainy_days_per_month')}</span>
            </div>
          </div>
        </Cell>
      ),
      'graph-temperature-day-night': (data, index) => {
        const max_height =
            Math.abs(data.values.min) +
            Math.abs(data.values.max) +
            this.state.temperature_offset,
          temp_norm =
            Math.abs(data.values.min) + this.state.temperature_offset / 2,
          mixin_rate = 0.25,
          colors = this.state.colors[data.type];

        const height =
            ((data.values.day[index - 1] + temp_norm) / max_height) *
            this.state.day_night_height,
          breakpoint =
            ((data.values.night[index - 1] + temp_norm) / max_height) * 100,
          breakpoint_start = breakpoint - breakpoint * mixin_rate,
          breakpoint_end =
            ((data.values.day[index - 1] + temp_norm) / max_height) * 100;

        const styles = {
          background: `linear-gradient(to top, ${colors.night_color}, ${
            colors.night_color
          } ${breakpoint_start.toFixed(2)}%, ${
            colors.day_color
          } ${breakpoint.toFixed(2)}%, ${
            colors.day_color
          } ${breakpoint_end.toFixed(2)}%, ${colors.day_top_color} )`,
          height: `${height.toFixed(2)}px`
        };

        return (
          <Cell
            className="graph-element-temperature-day-night"
            key={`graph-element-day-night-${index}`}
          >
            <div className="element-wrapper">
              <span className="temperature-day">
                {data.values.day[index - 1]}
              </span>
              <span className="temperature-graph" style={styles} />
              <span className="temperature-night">
                {data.values.night[index - 1]}
              </span>
            </div>
          </Cell>
        );
      },

      'graph-temperature-only-day': (data, index) => {
        const max_height =
            Math.abs(data.values.min) +
            Math.abs(data.values.max) +
            this.state.temperature_offset,
          temp_norm =
            Math.abs(data.values.min) + this.state.temperature_offset / 2,
          mixin_rate = 0.25,
          colors = this.state.colors[data.type];

        const height =
            ((data.values.day[index - 1] + temp_norm) / max_height) *
            this.state.day_night_height,
          breakpoint = ((0 + temp_norm) / max_height) * 100,
          breakpoint_start = breakpoint - breakpoint * mixin_rate,
          breakpoint_end =
            ((data.values.day[index - 1] + temp_norm) / max_height) * 100;

        const styles = {
          background: `linear-gradient(to top, ${colors.night_color}, ${
            colors.night_color
          } ${breakpoint_start.toFixed(2)}%, ${
            colors.day_color
          } ${breakpoint.toFixed(2)}%, ${
            colors.day_color
          } ${breakpoint_end.toFixed(2)}%, ${colors.day_top_color} )`,
          height: `${height.toFixed(2)}px`
        };

        return (
          <Cell
            className="graph-element-temperature-day-night"
            key={`graph-element-day-night-${index}`}
          >
            <div className="element-wrapper">
              <span className="temperature-day">
                {data.values.day[index - 1]}
              </span>
              <span className="temperature-graph" style={styles} />
              <span className="temperature-night"> - </span>
            </div>
          </Cell>
        );
      },
      'graph-simple-bars': (data, index) => {
        const height =
            (data.values[index - 1] / data.max) * this.state.simple_bars_height,
          styles = {
            borderBottom: `2px solid ${this.state.colors[data.type]}`,
            backgroundColor: this.state.colors[data.type],
            height: `${height.toFixed(2)}px`
          };
        return (
          <Cell
            className="graph-simple-bars"
            key={`graph-element-simple-bars-${index}`}
          >
            <div className="element-wrapper">
              <span
                className="graph-value"
                style={{ color: this.state.colors[data.type] }}
              >
                {data.values[index - 1]}
              </span>
              <span className="graph-bar" style={styles} />
            </div>
          </Cell>
        );
      }
    };

    return elements[name] ? (
      elements[name](data, index)
    ) : data.values.length ? (
      elements['graph-simple-bars'](data, index)
    ) : (
      <span> - </span>
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/weather/graph.js